"use client";

import { useState } from "react";
import type { Destination } from "./quiz-data";
import { trackEvent } from "@/lib/analytics";

const VARIANTS = [
  (name: string, pct: number) => `I got ${pct}% ${name}. What's your season?`,
  (name: string, pct: number) => `Apparently I'm moving to ${name}. Reckon you can beat ${pct}%?`,
  (name: string, pct: number) => `${name} with a ${pct}% match. Your turn.`,
];

type Props = {
  destination: Destination;
  matchPercent: number;
};

export function ShareRow({ destination, matchPercent }: Props) {
  const [copied, setCopied] = useState(false);
  const quizUrl = `https://peakwave.co/plan/quiz?d=${destination.id}&pct=${matchPercent}`;

  const text = VARIANTS[destination.id.charCodeAt(0) % VARIANTS.length](
    destination.name,
    matchPercent
  );
  const shareText = `${text} ${quizUrl}`;

  function share(method: "copy" | "whatsapp" | "instagram") {
    trackEvent("destination_quiz_shared", { destination: destination.id, method });
    if (method === "copy" || method === "instagram") {
      navigator.clipboard.writeText(shareText);
      setCopied(true);
      setTimeout(() => setCopied(false), 1800);
    }
  }

  const waHref = `https://wa.me/?text=${encodeURIComponent(shareText)}`;

  return (
    <div className="flex flex-wrap gap-2 justify-center mt-6">
      <button
        type="button"
        onClick={() => share("copy")}
        className="px-4 py-2.5 text-[13px] font-medium rounded-full bg-white border border-border-light hover:border-gold/40 hover:text-gold transition-colors"
      >
        {copied ? "Copied!" : "Copy share link"}
      </button>
      <a
        href={waHref}
        target="_blank"
        rel="noopener noreferrer"
        onClick={() => share("whatsapp")}
        className="px-4 py-2.5 text-[13px] font-medium rounded-full bg-white border border-border-light hover:border-gold/40 hover:text-gold transition-colors no-underline text-charcoal"
      >
        Share to WhatsApp
      </a>
      <button
        type="button"
        onClick={() => share("instagram")}
        className="px-4 py-2.5 text-[13px] font-medium rounded-full bg-white border border-border-light hover:border-gold/40 hover:text-gold transition-colors"
        aria-label="Copy caption for Instagram stories"
      >
        Copy for Instagram
      </button>
    </div>
  );
}
